import { createSlice } from "@reduxjs/toolkit";
import { getCompanyBaseURL, getCompanyToken, getStoredCompanyInfo, persistCompanySession } from "../utils/companySession";

const storedCompanyInfo = getStoredCompanyInfo();

const initialState = {
  token: sessionStorage.getItem("token"),
  userDetails: sessionStorage.getItem("userDetails")
    ? JSON.parse(sessionStorage.getItem("userDetails"))
    : sessionStorage.getItem("userDetails"),
  rememberMe: sessionStorage.getItem("rememberMe") ? true : false,
  credential: sessionStorage.getItem("credential"),
  companyList : sessionStorage.getItem("companyList")
  ? JSON.parse(sessionStorage.getItem("companyList"))
  : sessionStorage.getItem("companyList"),
  companyInfo: storedCompanyInfo,
  baseURL : getCompanyBaseURL(storedCompanyInfo) || sessionStorage.getItem("baseURL") ,
  validCompanyToken : getCompanyToken(storedCompanyInfo) || sessionStorage.getItem("validCompanyToken")
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
      setLoginData: (state, action) => {
        const nextCompanyInfo = action.payload.companyList?.[0] || null;
        state.token = action.payload.token;
        state.companyList = action.payload.companyList;
        state.companyInfo = nextCompanyInfo;
        state.baseURL = getCompanyBaseURL(nextCompanyInfo);
        state.validCompanyToken = getCompanyToken(nextCompanyInfo);
        state.userDetails = action.payload.loginUser;
        sessionStorage.setItem("token", action.payload.token);
        sessionStorage.setItem(
          "userDetails",
          JSON.stringify(action.payload.loginUser)
        );
        sessionStorage.setItem(
          "companyList",
          JSON.stringify(action.payload.companyList)
        );
        sessionStorage.setItem(
          "companyInfo",
          JSON.stringify(nextCompanyInfo)
        );
        persistCompanySession(nextCompanyInfo);
        state.rememberMe = action.payload.rememberMe ? true : false;
        if (action.payload.rememberMe) {
          const credential = {
            username: action.payload.username,
            password: action.payload.password,
          };
          state.credential = credential;
          sessionStorage.setItem("rememberMe", "true");
          sessionStorage.setItem("credential", JSON.stringify(credential));
        } else {
          state.credential = null;
          sessionStorage.removeItem("rememberMe");
          sessionStorage.removeItem("credential");
        }
      },
      setRememberMe: (state) => {
        state.rememberMe = !state.rememberMe;
      },
      setBaseURL : (state, action) => {
        state.baseURL = action.payload.companyList[0].baseURL;
        sessionStorage.setItem("baseURL", action.payload.companyList[0].baseURL);
      },
      setValidCompanyToken : (state, action) => {
        state.validCompanyToken = action.payload.companyList[0].token;
        sessionStorage.setItem("validCompanyToken", action.payload.companyList[0].token);
      },
      setTargetCompany: (state, action) => {
        const { baseURL = "", validCompanyToken = "", companyInfo = {} } = action.payload || {};
        const nextBaseURL = baseURL || getCompanyBaseURL(companyInfo);
        const nextCompanyToken = validCompanyToken || getCompanyToken(companyInfo);
        state.baseURL = nextBaseURL;
        state.validCompanyToken = nextCompanyToken;
        state.companyInfo = companyInfo;
        persistCompanySession({
          ...companyInfo,
          baseURL: nextBaseURL,
          validCompanyToken: nextCompanyToken,
        });
      }
    },
  });
  
  export const { setLoginData, setRememberMe, setBaseURL, setValidCompanyToken, setTargetCompany } = userSlice.actions;
  export const selectUserData = (state) => state.userInfo;
  
  export default userSlice.reducer;
